<template>
    <v-app id="inspire">


      <AppBar/>
    <v-main>
      <v-container

      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col cols="12" class="pa-0">
           <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <!-- <v-footer
      color="primary"
      app
    >
      <span class="white--text">&copy; 2019</span>
    </v-footer> -->
  </v-app>
</template>

<script >
import Vue from 'vue';
import AppBar from '@/components/AppBar.vue';
import BusinessNewDashboard from '@/components/BusinessNewDashboard.vue';

export default Vue.extend({
    components: {
    BusinessNewDashboard,
    AppBar
  },
  data: () =>
     ({
      drawer:null,
      logoImg:require('@/assets/logo-back.svg'),
      storeBusiness:[],
      id:0,
      businesscode:0,
      // agenturl:false,

  }),
  created()
  {

    //  this.loadData();

  },
  mounted()
    {
         this.storeBusiness=JSON.parse(localStorage.getItem('business'));
         if(this.storeBusiness.languagecode=='en'||this.storeBusiness.languagecode=='es'){
              this.$i18n.locale=this.storeBusiness.languagecode;
            }

    // //    if (this.$route.params.id) {
    // //   this.id = this.$route.params.id
    // //    }

    //     this.id=this.storeBusiness.id;
    //     this.businesscode=this.storeBusiness.businesscode;

      //  if(window.location.href.indexOf('agent') > -1)
      // {
      //   //alert('agent found');
      //   this.agenturl=true;
      // }
      // else
      // {
      //   this.agenturl=false;
      //   //alert('agent not found');

      // }

    },
  watch:
    {


    },
  methods:{

    loadData: function() {
        var self = this;
        setTimeout(function() {
            console.log("times over");

            if(window.location.href.indexOf('agent') > -1)
            {
              //alert('agent found');
              //self.agenturl=true;
            }
            else
            {
              //self.agenturl=false;
              //alert('agent not found');

            }

        }, 2000);
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  }
})
</script>
<style scoped>
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
	margin-right: 10px !important;
}
.v-main{
  padding:0px !important;
}

.agdashboard
{

	height: 100%;
	top:70px  !important;
	transform: translateX(0%);
	width: 256px;
	max-height: calc(100% - 70px)  !important;

}


</style>
